import type * as React from 'react'
import { Switch } from '@/components/ui/Switch'
import type { FieldBinding } from './types'

interface SwitchFieldProps<T extends object> extends FieldBinding<T> {
  label: React.ReactNode
  description?: React.ReactNode
  disabled?: boolean
}

export function SwitchField<T extends object>({
  form,
  name,
  label,
  description,
  disabled,
}: SwitchFieldProps<T>) {
  return (
    <label className="flex cursor-pointer items-start justify-between gap-3">
      <span className="min-w-0">
        <span className="text-fg block text-base font-medium">{label}</span>
        {description && <span className="text-fg-muted mt-0.5 block text-sm">{description}</span>}
      </span>
      <Switch
        id={name}
        checked={!!form.data[name]}
        onCheckedChange={(next) => form.setData(name, next as T[keyof T & string])}
        disabled={disabled}
        className="mt-0.5 shrink-0"
      />
    </label>
  )
}
